import * as React from 'react';
import LeftNav, { NavLevelModifier } from '../LeftNav/LeftNav';
import { SiteNavLink } from './SiteNavLink';

import './left-nav-item.scss';

export interface LeftNavItemProps {
  navItem: SiteNavLink;
  parentLevelModifier: NavLevelModifier;
  expandedGroup: string;
  onExpandGroup: (group: string) => void;
}

const LeftNavItem = ({
  navItem,
  parentLevelModifier,
  expandedGroup,
  onExpandGroup,
}: LeftNavItemProps): JSX.Element => {
  // Check if a Child of this Nav Item is Active.  We want to expand the NavItem if so.
  const childIsActive = (): boolean => {
    const active = navItem.subLinks ? navItem.subLinks.filter((x: SiteNavLink) => x.isActive === true).length > 0 : false;
    return active;
  };

  const [isExpanded, setIsExpanded] = React.useState(childIsActive());

  const {
    displayText,
    icon,
    subLinks,
    onClick,
    value,
    isActive,
    isRoot,
  } = navItem;

  const nextLevelModifier = parentLevelModifier === NavLevelModifier.Primary
    ? NavLevelModifier.Secondary
    : NavLevelModifier.Tertiary;

  const hasChildren = subLinks && !!subLinks.length;
  const toggleIsExpanded = (): void => {
    // Inform our Parent that this Group is Toggled (Expanded / Collapsed)
    onExpandGroup(isExpanded ? null : navItem.displayText);

    setIsExpanded(!isExpanded);
  };

  const clickHandler = onClick && !hasChildren
    ? (): void => onClick(value)
    : hasChildren
      ? toggleIsExpanded
      : null;

  const listItemClassNames = [
    'site-nav__item',
    isExpanded ? 'is-expanded' : '',
    isActive ? 'is-active' : '',
  ].filter((className) => !!className).join(' ');

  // The Expanded Group has Changed
  React.useEffect(() => {
    // Collapse this Group if a different one is Expanded
    if (hasChildren && isExpanded && (expandedGroup !== navItem.displayText)) {
      setIsExpanded(false);
    }
  }, [expandedGroup]);

  return (
    <li className={listItemClassNames}>
      <button type="button" className="site-nav__link" data-subnav="toggle" onClick={clickHandler}>
        {
          !!icon
          && (
            <svg className="u-icon-i-nav-temp-dims site-nav__icon">
              <use xlinkHref={`#${icon}`} />
            </svg>
          )
        }
        <span className={`site-nav__link-text ${isRoot ? '' : 'spanNormal'}`}>{displayText}</span>
        {
          hasChildren && <span className="nav-toggle__icon" />
        }
      </button>
      { hasChildren && <LeftNav links={subLinks} navLevelModifier={nextLevelModifier} isExpanded={isExpanded} />}
    </li>
  );
};

export default LeftNavItem;
